import { LocaleService } from '@philips-internal/oswald-ui-core/lib/services';
import moment from 'moment';
export const DATE_LOCALE = 'date-locale';
function getFormatter() {
    const name = DATE_LOCALE;
    const DEFAULT_DATE_FORMAT = 'DD-MMM-YYYY LT';
    function format(value, options) {
        const dateFormat = getPattern(options);
        moment.locale(LocaleService.getCurrentLocale());
        const momentValue = moment.utc(value);
        if (moment.isMoment(momentValue) && momentValue.isValid()) {
            return momentValue.format(dateFormat).toUpperCase();
        }
        return value;
    }
    function parse(value, options) {
        const dateFormat = getPattern(options);
        moment.locale(LocaleService.getCurrentLocale());
        const momentValue = moment(value, dateFormat);
        if (moment.isMoment(momentValue) && momentValue.isValid()) {
            return momentValue.utc().format();
        }
        return value ?? '';
    }
    function validate(value) {
        if (value) {
            return Promise.resolve([{ name, valid: true, message: '' }]);
        }
        return Promise.resolve([{ name, valid: true, message: '' }]);
    }
    function getPattern(options) {
        if (options && options.dateFormat) {
            return options.dateFormat;
        }
        return DEFAULT_DATE_FORMAT;
    }
    return {
        format,
        getPattern,
        parse,
        validate,
    };
}
const DateLocaleFormatter = getFormatter();
export default DateLocaleFormatter;
//# sourceMappingURL=date-locale-formatter.js.map